import { createServiceStore } from 'common/store';
import { INITIAL_STATE } from './constants';
import { customActions } from './custom-actions';
export var useSidebarStore = createServiceStore({
    initialValues: INITIAL_STATE,
    customActions: customActions,
});
